
import { createStorefrontApiClient } from '@shopify/storefront-api-client';
import { shopifyConst, isEnableShopify } from "./useShopifyConst";

const { storefrontAccessToken, domain, ApiVersion } = shopifyConst;

// 使用createStorefrontApiClient创建客户端
const createSafeClient = () => {
  let realClient = null;
  
  const handler = {
    get(target, prop) {
      // 没有 token 时，对任何方法调用都返回空操作的 Promise
      if (!storefrontAccessToken || !isEnableShopify) {
        if (typeof prop === 'string' && ['fetch', 'mutate'].includes(prop)) {
          return async () => ({ data: null, errors: [{ message: 'Client not initialized' }] });
        }
        return undefined;
      }
      
      // 有 token 时才创建真实 client
      if (!realClient) {
        realClient = createStorefrontApiClient({
          storeDomain: 'https:' + domain,
          publicAccessToken: storefrontAccessToken,
          apiVersion: ApiVersion,
        });
      }
      
      const value = realClient[prop];
      return typeof value === 'function' ? value.bind(realClient) : value;
    }
  };
  
  return new Proxy({}, handler);
};

export const client = createSafeClient();
